// import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
// import { catchError, throwError } from "rxjs";
// import { AuthService } from "../services/auth.service";
// import { inject } from "@angular/core";

// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   const authService = inject(AuthService);
//   let authUser
//   let authToken = '';
//   if(authService.isLoggedIn()) {
//     authUser = authService.getUserDetails(); 
//     authToken = authUser.token;
//   }
//   // console.log('authToken: ', authToken)
//   // Clone the request and add the authorization header
//   const authReq = req.clone({
//     setHeaders: {
//       Authorization: `Bearer ${authToken}`
//     }
//   });
  
//   // Pass the cloned request with the updated header to the next handler
//   return next(authReq).pipe(
//     catchError((err: any) => {
//       if (err instanceof HttpErrorResponse) {
//         // Handle HTTP errors
//         if (err.status === 401 || err.status === 403) {
//           // Unauthorized or Forbidden error, redirect to login page
//           console.error('Unauthorized request:', err);
//           authService.logout();
//         } else {
//           // Handle other HTTP error codes
//           console.error('HTTP error:', err);
//         }
//       } else {
//         // Handle non-HTTP errors
//         console.error('An error occurred:', err);
//       }

//       // Re-throw the error to propagate it further
//       return throwError(() => err); 
//     })
//   );
// }


// import { Injectable, inject } from '@angular/core';
// import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
// import { catchError, Observable, throwError } from 'rxjs';

// import { AuthService } from "../services/auth.service";
// import { Router } from '@angular/router';

// @Injectable()
// export class BasicAuthInterceptor implements HttpInterceptor {
//   private authService = inject(AuthService);
//   private router = inject(Router);

//   intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
//     // add auth header with jwt if user is logged in and request is to the api url
//     const currentUser = this.authService.getUserDetails();
//     const isLoggedIn = currentUser && currentUser.token && this.authService.getUserDetails();
//     const isExternalApi = this.isExternalUrl(request.url);
    
//     if (isLoggedIn && !isExternalApi) {
//       console.log('You are login', request)
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${currentUser.token}`
//         }
//       });
//     }
//     console.log(request)

//     return next.handle(request).pipe(
//       catchError((error: HttpErrorResponse) => {
//         console.error(error)
//         if (error.status === 401) {
//           // token expired or invalid
//           this.authService.logout();      // clear storage/session
//           this.router.navigate(['/login']); // redirect
//         }

//         return throwError(() => error);
//       })
//     );
//   }

//   // This allows is to test on localhost without sending auth headers to external services like labelary
//   private isExternalUrl(url: string): boolean {
//     // List of external domains that should not receive Authorization headers
//     const externalDomains = [
//       'api.labelary.com',
//       'labelary.com'
//     ];
    
//     return externalDomains.some(domain => url.includes(domain));
//   }
// }


import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  let authUser
  let authToken = '';
  if(authService.isLoggedIn()) {
    authUser = authService.getUserDetails(); 
    authToken = authUser.token;
  }
  console.log('authToken: ', authToken)
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authToken}`
    }
  });

  // Pass the request to the next interceptor (or the backend)
  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === 401 || err.status === 403) {
          // Unauthorized or Forbidden error, redirect to login page
          console.error('Unauthorized request:', err);
          authService.logout();
        } else {
          // Handle other HTTP error codes
          console.error('HTTP error:', err);
        }
      } else {
        // Handle non-HTTP errors
        console.error('An error occurred:', err);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err); 
    })
  );
};